module.exports = __webpack_public_path__ + "static/media/ThoughtLeadership_Post03-Image.4e93dc25.jpg";